import React from 'react';
import { Table, Tag, Typography, Card, Space } from 'antd';
import { ToolOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

interface FirmwareHistoryEntry {
  from_firmware: string | null;
  to_firmware: string | null;
  result: string | null;
  created_time: string | null;
  start_time: string | null;
  end_time: string | null;
}

interface FirmwareHistoryTableProps {
  firmwareHistory: FirmwareHistoryEntry[];
}

function resultTag(result: string | null) {
  if (!result) return <Tag>Unknown</Tag>;
  const lower = result.toLowerCase();
  if (lower.includes('success')) return <Tag color="success">Success</Tag>;
  if (lower.includes('fail')) return <Tag color="error">Failed</Tag>;
  return <Tag>{result}</Tag>;
}

const columns = [
  {
    title: 'Date',
    dataIndex: 'created_time',
    key: 'created_time',
    width: 110,
    render: (val: string | null) => val ? dayjs(val).format('YYYY-MM-DD') : '--',
  },
  {
    title: 'From',
    dataIndex: 'from_firmware',
    key: 'from_firmware',
    render: (val: string | null) => val ? <Typography.Text code style={{ fontSize: 12 }}>{val}</Typography.Text> : '--',
  },
  {
    title: 'To',
    dataIndex: 'to_firmware',
    key: 'to_firmware',
    render: (val: string | null) => val ? <Typography.Text code style={{ fontSize: 12 }}>{val}</Typography.Text> : '--',
  },
  {
    title: 'Result',
    dataIndex: 'result',
    key: 'result',
    width: 100,
    render: resultTag,
  },
];

const FirmwareHistoryTable: React.FC<FirmwareHistoryTableProps> = ({ firmwareHistory }) => {
  if (firmwareHistory.length === 0) return null;

  return (
    <Card
      title={<Space><ToolOutlined /><span>Firmware History</span></Space>}
      size="small"
      style={{ marginBottom: 16 }}
    >
      <Table
        dataSource={firmwareHistory}
        columns={columns}
        rowKey={(_, i) => String(i)}
        size="small"
        pagination={firmwareHistory.length > 5 ? { pageSize: 5, size: 'small' } : false}
      />
    </Card>
  );
};

export default FirmwareHistoryTable;
